import { RootState } from '@/store'

export const selectHelperData = (state: RootState) => state.three.helperData
export const selectLoadedPercent = (state: RootState) => state.three.percent
export const selectLoadedWorld = (state: RootState) => state.three.loadedWorld
